import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { noResultsText } from "../../custom_api/api";
import { ActivitySummary } from "../components/activity_summary";
import { trackActivityClick as trackClusterActivityClick } from "./library/tracking";
export const ActivityCluster = (p)=>/*#__PURE__*/ _jsxs("section", {
        className: "block block--activity-cluster container--lg align--center",
        "data-anchor": p.slug,
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "block__header container--m align--center",
                children: [
                    p.title && /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l container--xs",
                        children: p.title
                    }),
                    p.description && /*#__PURE__*/ _jsx("div", {
                        className: "block__intro container--s text--styled",
                        children: /*#__PURE__*/ _jsx("p", {
                            children: p.description
                        })
                    })
                ]
            }),
            p.activitySummaries.isEmpty() ? /*#__PURE__*/ _jsx("div", {
                className: "text--styled container--m align--center",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold container--s",
                    children: noResultsText
                })
            }) : /*#__PURE__*/ _jsx("ul", {
                className: "row teasers",
                children: p.activitySummaries.map((s, i)=>/*#__PURE__*/ _jsx(ActivitySummary, {
                        headingLevel: "h3",
                        onClick: ()=>trackClusterActivityClick(s.title, p.title),
                        ...s
                    }, `activity-summary-${i}`))
            })
        ]
    });
{}